/* Chocbox cart helpers (assets/cbb-bundle-join.js, loaded on every page from snippets/bundleapp-theme-custom.liquid)

   A) Later jars join the box deal.
      Kaching prices each bundle on its own, so a jar added AFTER a Pick 3 / Pick 5 box is already in the cart
      (the cart's "Bundle & Save" row, a product page, the builder again) would pay full price. After every
      cart change this moves any full-price jar into the cart's discounted box bundle (4 jars keep the Pick 3 %,
      5+ get the Pick 5 %), adds the next level's free gift when a box grows into it (e.g. the DIY kit at 5),
      and removes a bundle "free gift" that is being charged (e.g. the box dropped below the gift's level).

   B) "Subscribe & Save" switch in the cart (side cart and /cart page), styled like the Kaching widget.
      It uses the same Kaching Subscriptions plans as the product pages (same names, same %), and starts on
      DEFAULT_PLAN (below) when turned on from the cart.
      On: every item that has those plans switches to the chosen delivery plan, right in the cart.
      Off: they go back to one-time. Bundle discounts keep working either way.
      The switch ticks the moment it's tapped and shows "Updating your cart…" until the cart has caught up;
      a tap on Checkout during that wait goes through as soon as it's done.
      While it's on, items added later follow the subscription too. Free gifts always stay one-time. */
(function () {
  if (window.__cbbJoin) return;
  window.__cbbJoin = true;

  // Products that count as a jar for the box deal. Add a handle here if you launch a new flavor as its own product.
  var JARS = [
    'build-your-dubai-dip-box',
    'dubai-dip',
    'dubai-dip-with-ganache',
    'dubai-dip-chewy-cookie',
    'strawtella-dubai-dip-12oz',
    'smooth-pistachio-cream-dubai-dip-2',
    'chocolate-hazelnut-crunch-copy',
    'pumpkin-spice-cookie-butter',
    'chocbox-drizzles-pistachio-hazelnut-and-espresso-8oz-or-20oz'
  ];
  var SUB_APP = 'kaching_subscriptions';   // only Kaching Subscriptions plans are used
  var SUB_ATTR = '_cbb_sub';               // cart attribute: the plan id while the cart switch is on
  var SUB_TEXT = 'Zero Commitment, Cancel Anytime';
  // The delivery plan the cart switch picks when a shopper turns it on: any words from the Kaching plan's name
  // ("every month", "every 2 weeks", "every week"). Leave it '' to use Kaching's first plan.
  var DEFAULT_PLAN = 'every month';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var realFetch = window.fetch.bind(window);
  var JSON_H = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  var MUTATION = /\/cart\/(add|change|update)(\.js)?(\?|$)/;
  var timer = null, running = false, again = false, busy = false, last = null, dirty = true;

  function track(name) { try { if (window.clarity) window.clarity('event', name); } catch (e) {} }
  function money(c) { return '$' + (Math.round(c) / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function bundle(it) {
    var raw = it.properties && it.properties.__kaching_bundles;
    if (!raw) return null;
    try { var j = JSON.parse(raw); j.raw = raw; return j; } catch (e) { return null; }
  }
  function hasDeal(it) {
    return (it.line_level_discount_allocations || []).some(function (a) {
      var t = a.discount_application && a.discount_application.type;
      return a.amount > 0 && t !== 'discount_code' && t !== 'manual';
    });
  }
  function isGift(it) { var b = bundle(it); return !!(b && b.gift); }
  function isJar(it) { return JARS.indexOf(it.handle) >= 0 && !isGift(it) && it.original_price > 0; }
  function jarsIn(cart, id) {
    var n = 0;
    (cart.items || []).forEach(function (it) { var b = bundle(it); if (b && b.id === id && JARS.indexOf(it.handle) >= 0 && !b.gift) n += it.quantity; });
    return n;
  }

  async function getCart() {
    var r = await realFetch(root + 'cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
    return r.json();
  }
  function post(path, body) {
    return realFetch(root + path, { method: 'POST', headers: JSON_H, body: JSON.stringify(body) });
  }

  /* ---------------- A) box deal ---------------- */

  // The discounted box bundle with the most jars, or null when the cart has none.
  function target(cart) {
    var groups = {}, best = null;
    (cart.items || []).forEach(function (it) {
      var b = bundle(it);
      if (!b || !b.id || !isJar(it) || !hasDeal(it)) return;
      var g = groups[b.id] || (groups[b.id] = { id: b.id, deal: b.deal, v: b.v, raw: b.raw, qty: 0 });
      if (b.main) g.raw = b.raw;
      g.qty += it.quantity;
    });
    Object.keys(groups).forEach(function (k) { if (!best || groups[k].qty > best.qty) best = groups[k]; });
    return best;
  }
  function strays(cart, t) {
    return (cart.items || []).filter(function (it) {
      var b = bundle(it);
      return isJar(it) && !hasDeal(it) && !(b && b.id === t.id);
    });
  }

  // Kaching's deal levels (Pick 3, Pick 5…) with their free gifts.
  async function levels(dealId) {
    try {
      var deals = await window.kachingBundlesApi.fetchDeals();
      var d = (deals || []).filter(function (x) { return x.nanoId === dealId; })[0];
      return d ? d.dealBars.filter(function (b) { return b.quantity; }).sort(function (a, b) { return a.quantity - b.quantity; }) : null;
    } catch (e) { return null; }
  }
  // Last jar count we saw per box, so a box that grows into the next level (by "+" or a merge) gets that level's gift once.
  var mem = {};
  function memory() { try { return JSON.parse(sessionStorage.getItem('cbb_box_jars') || '{}'); } catch (e) { return mem; } }
  function remember(m) { mem = m; try { sessionStorage.setItem('cbb_box_jars', JSON.stringify(m)); } catch (e) {} }
  function levelFor(bars, n) { var l = null; (bars || []).forEach(function (b) { if (b.quantity <= n) l = b; }); return l; }

  async function addGifts(cart, t, before) {
    var bars = await levels(t.deal); if (!bars) return 0;
    var was = levelFor(bars, before), now = levelFor(bars, jarsIn(cart, t.id));
    if (!now || (was && was.quantity >= now.quantity)) return 0;
    var have = {};
    (cart.items || []).forEach(function (it) { var b = bundle(it); if (b && b.id === t.id && b.gift) have[it.product_id] = 1; });
    var items = [];
    (now.freeGifts || []).forEach(function (g) {
      var vid = (g.variantIds && g.variantIds[0]) || g.variantId;
      if (!vid || have[g.productId] || g.applyOnlyForSubscriptions) return;
      items.push({ id: Number(vid), quantity: g.quantity || 1, properties: { __kaching_bundles: JSON.stringify({ id: t.id, deal: t.deal, v: t.v, gift: g.id }), _cbb_gift: 'yes' } });
    });
    if (!items.length) return 0;
    var r = await post('cart/add.js', { items: items });
    return r.ok ? items.length : 0;
  }

  // A bundle "free gift" line that is being charged is never what the shopper meant to buy: the box dropped
  // below the gift's level (e.g. 5 jars → 4), the box was emptied, or it's a duplicate. Take it out.
  // Gifts that are still free are never touched.
  async function dropPaidGifts(cart) {
    var n = 0, list = (cart.items || []).filter(function (it) { return isGift(it) && it.original_price > 0 && it.final_line_price > 0; });
    for (var i = 0; i < list.length; i++) {
      var it = list[i], off = 0;
      (it.line_level_discount_allocations || []).forEach(function (a) { off += a.amount; });
      var keep = Math.min(it.quantity, Math.floor((off + 1) / it.original_price));   // units that are still free
      var r = await post('cart/change.js', { id: it.key, quantity: keep });
      if (r.ok) n++;
    }
    return n;
  }

  /* ---------------- B) subscribe switch ---------------- */

  // Kaching plans per product handle (read from the product's own feed, so it always matches your Kaching setup).
  var planCache = {};
  function productPlans(handle) {
    if (!planCache[handle]) {
      planCache[handle] = realFetch(root + 'products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var out = [];
          ((p && p.selling_plan_groups) || []).forEach(function (g) {
            if (g.app_id !== SUB_APP) return;
            (g.selling_plans || []).forEach(function (s) {
              var a = (s.price_adjustments || [])[0];
              out.push({ id: s.id, name: s.name, pct: a && a.value_type === 'percentage' ? Number(a.value) : 0 });
            });
          });
          return out;
        })
        .catch(function () { return []; });
    }
    return planCache[handle];
  }
  async function subInfo(cart) {
    var lines = (cart.items || []).filter(function (it) { return !isGift(it) && it.original_price > 0; });
    var map = {}, handles = {};
    lines.forEach(function (it) { handles[it.handle] = 1; });
    await Promise.all(Object.keys(handles).map(function (h) { return productPlans(h).then(function (p) { map[h] = p; }); }));
    var elig = lines.filter(function (it) { return (map[it.handle] || []).length; });
    return { elig: elig, map: map, plans: elig.length ? map[elig[0].handle] : [] };
  }
  function planOf(it) { var a = it.selling_plan_allocation; return a && a.selling_plan ? a.selling_plan.id : null; }
  function onKaching(it, info) { var id = planOf(it); return !!id && (info.map[it.handle] || []).some(function (p) { return p.id === id; }); }
  function defPlan(list) {
    var k = String(DEFAULT_PLAN || '').toLowerCase();
    for (var i = 0; k && i < list.length; i++) if (String(list[i].name).toLowerCase().indexOf(k) >= 0) return list[i];
    return list[0] || null;
  }
  function pick(list, want) {
    if (!want) return null;
    for (var i = 0; i < list.length; i++) if (String(list[i].id) === String(want.id)) return list[i];
    for (var j = 0; j < list.length; j++) if (want.name && list[j].name === want.name) return list[j];
    return defPlan(list);
  }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  // Which eligible lines need a different plan (`want`, or one-time when want is null): [{ it, to }]
  function plansTodo(info, want, onlyOneTime, skip) {
    var todo = [];
    info.elig.forEach(function (it) {
      var cur = planOf(it);
      if (onlyOneTime && cur) return;
      if (!want && !onKaching(it, info)) return;          // never touch another app's plan
      var p = pick(info.map[it.handle], want), to = p ? p.id : null;
      if (cur === to || (skip && skip[lineSig(it) + '>' + to])) return;
      todo.push({ it: it, to: to });
    });
    return todo;
  }
  function lineSig(it) { return it.variant_id + '|' + JSON.stringify(it.properties || {}); }

  // Fast way: every line in ONE request, through Shopify's storefront cart API (carts need no token there).
  // If it's ever refused, the switch quietly uses the one-line-at-a-time way for the rest of that page view.
  var SF_API = root + 'api/2025-07/graphql.json';
  var sfOff = false;
  async function sf(query, variables) {
    var r = await realFetch(SF_API, { method: 'POST', headers: JSON_H, body: JSON.stringify({ query: query, variables: variables }) });
    if (!r.ok) throw new Error('storefront ' + r.status);
    var j = await r.json();
    if (!j || !j.data || (j.errors && j.errors.length)) throw new Error('storefront error');
    return j.data;
  }
  function sameProps(attrs, props) {
    var a = {}, n = 0;
    (attrs || []).forEach(function (x) { a[x.key] = String(x.value); n++; });
    var keys = Object.keys(props || {});
    return keys.length === n && keys.every(function (k) { return a[k] === String(props[k]); });
  }
  async function setPlansFast(cart, todo) {
    var id = 'gid://shopify/Cart/' + cart.token;
    var d = await sf('query($id:ID!){cart(id:$id){lines(first:250){nodes{id quantity attributes{key value} sellingPlanAllocation{sellingPlan{id}} merchandise{... on ProductVariant{id}}}}}}', { id: id });
    var nodes = (d.cart && d.cart.lines && d.cart.lines.nodes) || [], used = {}, lines = [];
    todo.forEach(function (t) {
      var it = t.it, cur = planOf(it), hit = null;
      nodes.forEach(function (n) {
        if (hit || used[n.id] || !n.merchandise) return;
        var np = n.sellingPlanAllocation ? Number(String(n.sellingPlanAllocation.sellingPlan.id).split('/').pop()) : null;
        if (String(n.merchandise.id).split('/').pop() === String(it.variant_id) && np === cur && n.quantity === it.quantity && sameProps(n.attributes, it.properties)) hit = n;
      });
      if (!hit) throw new Error('line not found');
      used[hit.id] = 1;
      lines.push({ id: hit.id, sellingPlanId: t.to ? 'gid://shopify/SellingPlan/' + t.to : null });
    });
    var m = await sf('mutation($id:ID!,$lines:[CartLineUpdateInput!]!){cartLinesUpdate(cartId:$id,lines:$lines){cart{id} userErrors{message}}}', { id: id, lines: lines });
    var res = m.cartLinesUpdate;
    if (!res || !res.cart || (res.userErrors || []).length) throw new Error('storefront refused');
    return lines.length;
  }
  // Put eligible lines on `want` (a plan), or back to one-time when want is null. `cart` = a cart we already have
  // (optional). Returns { n, cart } (cart is null when it has to be read again).
  async function setPlans(want, onlyOneTime, cart) {
    if (!cart) cart = await getCart();
    var todo = plansTodo(await subInfo(cart), want, onlyOneTime);
    if (!todo.length) return { n: 0, cart: cart };
    if (!sfOff && cart.token) {
      try { return { n: await setPlansFast(cart, todo), cart: null }; }
      catch (e) { sfOff = true; cart = null; }
    }
    // The other way: one line per request. Each reply is the next cart, so the next line is always looked up fresh.
    var n = 0, misses = 0, skip = {};
    for (var step = 0; step < 40; step++) {
      if (!cart) cart = await getCart();
      todo = plansTodo(await subInfo(cart), want, onlyOneTime, skip);
      if (!todo.length) break;
      var t = todo[0], sig = lineSig(t.it) + '>' + t.to;
      var r = await post('cart/change.js', { id: t.it.key, quantity: t.it.quantity, selling_plan: t.to });
      if (r.ok) { n++; try { cart = await r.json(); } catch (e) { cart = null; } }
      else { cart = null; misses++; }
      if (skip[sig + '#']) skip[sig] = 1;                 // asked twice and it didn't stick: leave that line alone
      skip[sig + '#'] = 1;
      if (misses > 3) break;
    }
    return { n: n, cart: cart };
  }
  function attrPlan(cart, info) {
    var v = (cart.attributes || {})[SUB_ATTR];
    if (!v) return null;
    return pick(info.plans, { id: v, name: '' }) || null;
  }

  // The switch answers a tap right away (it ticks and says "Updating your cart…"), then the cart catches up.
  // More taps while it works just change where it's heading (the last tap wins), and a tap on Checkout waits
  // until the cart matches what they see.
  var goal = null, work = null, heldCheckout = null, planChangedAt = 0;
  function setSwitch(on, planId) {
    goal = { on: !!on, plan: on ? (planId || null) : null };
    busy = true;
    paint();
    if (!work) work = apply().then(function () { work = null; }, function () { work = null; });
  }
  async function apply() {
    var cart = null, done = 0;
    try {
      for (var t = 0; running && t < 100; t++) await wait(60);       // a cart check already running finishes first
      if (last && !dirty && Date.now() - last.at < 20000) cart = last.cart;   // fresh enough: skip a read
      for (var round = 0; round < 4 && goal; round++) {
        var g = goal;
        if (!cart) cart = await getCart();
        var info = await subInfo(cart);
        var subbed = info.elig.filter(function (it) { return onKaching(it, info); });
        var want = !g.on ? null : g.plan ? pick(info.plans, { id: g.plan, name: '' }) :
          (attrPlan(cart, info) || (subbed[0] && pick(info.plans, { id: planOf(subbed[0]), name: '' })) || defPlan(info.plans));
        var res = await setPlans(want, false, cart);
        cart = res.cart;
        var a = {}; a[SUB_ATTR] = want ? String(want.id) : '';
        if (!cart || String((cart.attributes || {})[SUB_ATTR] || '') !== a[SUB_ATTR]) {
          var r = await post('cart/update.js', { attributes: a });
          cart = null;
          if (r.ok) { try { cart = await r.json(); } catch (e) {} }
        }
        done++;
        track(g.on ? 'cbb_cart_subscribe_on' : 'cbb_cart_subscribe_off');
        if (goal === g) goal = null;                                  // nothing new was tapped meanwhile
      }
    } catch (e) {}
    goal = null;
    try { if (!cart) cart = await getCart(); last = { cart: cart, info: await subInfo(cart), at: Date.now() }; dirty = false; } catch (e) {}
    busy = false;
    if (done) planChangedAt = Date.now();
    paint();
    if (heldCheckout) { goCheckout(); return; }
    if (done && /\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    try { if (done && window.cart && typeof window.cart.getCart === 'function') window.cart.getCart(); } catch (e) {}
    if (again || done) { again = false; schedule(); }               // one normal cart check afterwards (gifts etc.)
  }
  // Checkout tapped while the switch was still updating (or right after): carry on to checkout once the cart is right.
  // Right after the plans change, Shopify can still be re-checking discount codes, and a checkout started in that
  // moment dropped a WELCOME code the shopper still qualified for. So wait (up to ~3s) until the cart says its codes
  // apply again, then hand them to checkout explicitly.
  async function goCheckout() {
    var held = heldCheckout; heldCheckout = null; planChangedAt = 0;
    var codes = [];
    for (var t = 0; t < 10; t++) {
      var c = null;
      try { c = await getCart(); } catch (e) {}
      if (!c) break;
      var all = (c.discount_codes || []).filter(function (d) { return d && d.code; });
      var subbed = (c.items || []).some(function (it) { return it.selling_plan_allocation; });
      codes = all.filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
      if (subbed || codes.length === all.length) break;      // subscribed: codes for one-time orders won't apply anyway
      await wait(300);
    }
    var inDrawer = !!(held && held.closest && held.closest('#cart-drawer'));
    var fresh = document.querySelector((inDrawer ? '#cart-drawer ' : '') + 'form[data-cart-form] [name="checkout"]');
    if (fresh && fresh.isConnected && !fresh.disabled) {
      var f = fresh.form;
      if (f && codes.length) {
        var inp = f.querySelector('[name="discount"]') || (f.id && document.querySelector('[name="discount"][form="' + f.id + '"]'));
        if (!inp) { inp = document.createElement('input'); inp.type = 'hidden'; inp.name = 'discount'; f.appendChild(inp); }
        if (!inp.value) inp.value = codes.join(',');
      }
      fresh.__cbbGo = true;                                  // our own click: let it through
      fresh.click();
      return;
    }
    location.href = root + 'checkout' + (codes.length ? '?discount=' + encodeURIComponent(codes.join(',')) : '');
  }
  document.addEventListener('click', function (e) {
    var recent = !busy && planChangedAt && Date.now() - planChangedAt < 3000;
    if (!busy && !recent) return;
    var b = e.target && e.target.closest && e.target.closest('[name="checkout"], a[href$="/checkout"]');
    if (!b || b.__cbbGo) return;
    e.preventDefault(); e.stopImmediatePropagation();
    heldCheckout = b;
    b.classList.add('cbb-wait');
    if (recent) { planChangedAt = 0; goCheckout(); }
  }, true);

  var CSS =
    '.cbb-sub{margin:0 0 12px}' +
    '.cbb-sub__card{border:2px dashed #b7e400;border-radius:26px;background:#fff5ef;padding:10px 12px}' +
    '.cbb-sub__spin{flex:0 0 18px;width:18px;height:18px;box-sizing:border-box;border:2px solid #e8d9d0;border-top-color:#744034;border-radius:50%;animation:cbb-spin .7s linear infinite}' +
    '@keyframes cbb-spin{to{transform:rotate(360deg)}}' +
    '.cbb-wait{opacity:.6!important;cursor:progress!important}' +
    '.cbb-sub__row{all:unset;box-sizing:border-box;display:flex;align-items:center;gap:12px;width:100%;cursor:pointer;padding:2px 4px;font-family:inherit}' +
    '.cbb-sub__row:focus-visible{outline:2px solid #744034;outline-offset:4px;border-radius:12px}' +
    '.cbb-sub__box{flex:0 0 20px;width:20px;height:20px;border:2px solid #b7e400;background:#fff;box-sizing:border-box;display:flex;align-items:center;justify-content:center}' +
    '.cbb-sub__box svg{width:14px;height:14px;opacity:0;transition:opacity .15s}' +
    '.cbb-sub.is-on .cbb-sub__box svg{opacity:1}' +
    '.cbb-sub__text{display:flex;flex-direction:column;flex:1;min-width:0;text-align:left}' +
    '.cbb-sub__title{font-size:15px;font-weight:700;color:#000;line-height:21px;text-transform:none;letter-spacing:0}' +
    '.cbb-sub__subtitle{font-size:13px;font-weight:400;color:#555;line-height:18px;text-transform:none;letter-spacing:0}' +
    '.cbb-sub__save{font-size:14px;font-weight:700;color:#000;white-space:nowrap}' +
    '.cbb-sub__plan{display:block;width:100%;margin:8px 0 2px;height:40px;border:0;border-radius:13px;background:#fff;padding:7px 25px 7px 10px;font-size:14px;color:#000;font-family:inherit}' +
    '.cbb-sub__note{margin:8px 4px 2px;font-size:12px;line-height:1.35;color:#744034;text-transform:none;letter-spacing:0}' +
    '.cart__item__subscription-upsell{display:none!important}';
  var CHECK = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8.5l3.2 3.1L13 4.6" fill="none" stroke="#b7e400" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function hosts() { return Array.prototype.slice.call(document.querySelectorAll('form[data-cart-form] .cart__foot-inner')); }

  function paint() {
    if (!last) return;
    if (!document.getElementById('cbb-sub-css')) {
      var st = document.createElement('style'); st.id = 'cbb-sub-css'; st.textContent = CSS; (document.head || document.body).appendChild(st);
    }
    var cart = last.cart, info = last.info;
    var subbed = info.elig.filter(function (it) { return onKaching(it, info); });
    var chosen = attrPlan(cart, info);
    var on = !!chosen || (subbed.length > 0 && subbed.length === info.elig.length);
    var plan = chosen || (subbed[0] && pick(info.plans, { id: planOf(subbed[0]), name: '' })) || defPlan(info.plans);
    // while it's working, show what they tapped, not what the cart still says
    if (goal) {
      on = goal.on;
      if (goal.on && goal.plan) plan = pick(info.plans, { id: goal.plan, name: '' });
    }
    var pct = plan ? plan.pct : 0;

    var codes = (cart.discount_codes || []).filter(function (d) { return d && d.code; });
    var save = '';
    if (!on && !busy && !codes.length && pct) {
      var base = 0; info.elig.forEach(function (it) { base += it.final_line_price; });
      if (base > 0) save = 'Save ' + money(base * pct / 100);
    }
    // Most discount codes (e.g. the WELCOME codes) only work on one-time orders. Say so when one stops
    // covering the subscribed items (it drops off completely, or only covers the one-time items left).
    var note = '';
    if (on && !busy && subbed.length) {
      var lost = codes.filter(function (d) { return d.applicable === false; })[0];
      var miss = lost ? lost.code : '';
      if (!miss) {
        var paid = 0; (cart.items || []).forEach(function (it) { if (it.final_line_price > 0) paid += it.final_line_price; });
        (cart.cart_level_discount_applications || []).forEach(function (a) {
          if (miss || a.type !== 'discount_code' || a.value_type !== 'percentage') return;
          if (a.total_allocated_amount < paid * Number(a.value) / 100 * 0.95) miss = a.title;
        });
      }
      if (miss) note = 'Your code ' + miss + ' is for one-time orders, so it doesn’t apply to subscribed items.';
    }

    var html =
      '<div class="cbb-sub__card">' +
        '<button type="button" class="cbb-sub__row" role="checkbox" aria-checked="' + on + '" aria-busy="' + busy + '" data-cbb-act="toggle">' +
          '<span class="cbb-sub__box">' + CHECK + '</span>' +
          '<span class="cbb-sub__text"><span class="cbb-sub__title">Subscribe &amp; Save ' + esc(pct) + '%</span><span class="cbb-sub__subtitle">' + esc(busy ? 'Updating your cart…' : SUB_TEXT) + '</span></span>' +
          (busy ? '<span class="cbb-sub__spin" aria-hidden="true"></span>' : (save ? '<span class="cbb-sub__save">' + esc(save) + '</span>' : '')) +
        '</button>' +
        (on ? '<select class="cbb-sub__plan" aria-label="Delivery frequency" data-cbb-act="plan">' + info.plans.map(function (p) {
          return '<option value="' + esc(p.id) + '"' + (plan && p.id === plan.id ? ' selected' : '') + '>' + esc(p.name) + '</option>';
        }).join('') + '</select>' : '') +
        (note ? '<p class="cbb-sub__note">' + esc(note) + '</p>' : '') +
      '</div>';

    hosts().forEach(function (host) {
      var el = host.querySelector('[data-cbb-sub]');
      if (!info.elig.length || !info.plans.length) { if (el) el.parentNode.removeChild(el); return; }
      if (!el) {
        el = document.createElement('div');
        el.className = 'cbb-sub';
        el.setAttribute('data-cbb-sub', '');
        host.insertBefore(el, host.firstChild);
        el.addEventListener('click', function (e) {
          var b = e.target.closest && e.target.closest('[data-cbb-act="toggle"]');
          if (!b) return;
          e.preventDefault();
          var s = el.querySelector('[data-cbb-act="plan"]');
          setSwitch(b.getAttribute('aria-checked') !== 'true', s ? s.value : null);
        });
        el.addEventListener('change', function (e) {
          if (e.target && e.target.getAttribute('data-cbb-act') === 'plan') { e.stopPropagation(); setSwitch(true, e.target.value); }
        });
      }
      if (el.__html !== html) { el.innerHTML = html; el.__html = html; }
      el.classList.toggle('is-on', on);
      el.classList.toggle('is-busy', busy);
    });
  }

  /* ---------------- after every cart change ---------------- */

  async function join() {
    if (running || busy) { again = true; return; }   // never while the subscribe switch is changing the cart
    // The box builder is putting a box in the cart (its extra jars go in a moment before the box itself): wait.
    if (window.__cbbAdding && Date.now() - window.__cbbAdding < 15000) { clearTimeout(timer); timer = setTimeout(join, 800); return; }
    running = true;
    var changed = 0, cart = null;
    try {
      cart = await getCart();

      // B first: while the cart switch is on, newly added items follow the subscription.
      if ((cart.attributes || {})[SUB_ATTR]) {
        var info0 = await subInfo(cart);
        if (!info0.elig.length) {
          var a0 = {}; a0[SUB_ATTR] = '';
          await post('cart/update.js', { attributes: a0 });
          cart = await getCart();
        } else {
          var r0 = await setPlans(attrPlan(cart, info0) || defPlan(info0.plans), true, cart);
          if (r0.n) { changed += r0.n; cart = r0.cart || await getCart(); }
        }
      }

      // A: jars outside the box deal join it; gifts follow the box level.
      var t = target(cart);
      if (t) {
        var seen = memory(), before = jarsIn(cart, t.id), list = strays(cart, t), moved = 0;
        var from = seen[t.id] != null ? Math.min(seen[t.id], before) : before;
        for (var i = 0; i < list.length; i++) {
          var it = list[i], props = {};
          for (var k in (it.properties || {})) props[k] = it.properties[k];
          props.__kaching_bundles = t.raw;
          props._box_extra = 'yes';
          var r = await post('cart/change.js', { id: it.key, quantity: it.quantity, properties: props });
          if (r.ok) moved++;
        }
        if (moved) { changed += moved; cart = await getCart(); }
        var now = jarsIn(cart, t.id);
        if (now > from) changed += await addGifts(cart, t, from);
        seen[t.id] = now; remember(seen);
      }
      if (changed) cart = await getCart();
      var dropped = await dropPaidGifts(cart);
      if (dropped) { changed += dropped; cart = await getCart(); }
    } catch (e) {}
    running = false;

    if (changed) {
      try { if (window.clarity) window.clarity('event', 'cbb_jar_joined_bundle'); } catch (e) {}
      if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
      try { if (window.cart && typeof window.cart.getCart === 'function') window.cart.getCart(); } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('cbb:bundle-joined', { detail: { changed: changed } })); } catch (e) {}
    }
    try { if (cart && !busy) { last = { cart: cart, info: await subInfo(cart), at: Date.now() }; dirty = false; paint(); } } catch (e) {}
    if (again) { again = false; schedule(); }
  }
  function schedule() { dirty = true; clearTimeout(timer); timer = setTimeout(join, 700); }

  // Watch the store's own cart calls (theme, Kaching, upsells, the builder) and check after each one.
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = realFetch(input, init);
    if (MUTATION.test(url)) p.then(schedule, schedule);
    return p;
  };
  var xOpen = XMLHttpRequest.prototype.open, xSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, url) { this.__cbbCart = MUTATION.test(String(url || '')); return xOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () { if (this.__cbbCart) this.addEventListener('loadend', schedule); return xSend.apply(this, arguments); };

  // The side cart builds its footer when it first opens: put the switch back whenever it's missing.
  var drawTimer = null;
  function watchDrawer() {
    var spots = [document.getElementById('cart-drawer'), document.querySelector('[data-cart-page]')].filter(Boolean);
    if (!spots.length) spots = [document.body];
    try {
      var mo = new MutationObserver(function () {
        clearTimeout(drawTimer);
        var missing = hosts().some(function (h) { return !h.querySelector('[data-cbb-sub]'); });
        if (!missing) return;
        if (last) { paint(); return; }                  // put it straight back (no flicker after a redraw)
        drawTimer = setTimeout(schedule, 120);
      });
      spots.forEach(function (s) { mo.observe(s, { childList: true, subtree: true }); });
    } catch (e) {}
  }

  function start() { watchDrawer(); schedule(); }
  document.addEventListener('cbb:box-added', function () { schedule(); });
  // Also check once on every page load (covers adds that reloaded the page or went straight to /cart).
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();